import { useParams } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import BabyNamePrivacy from './privacy/babyname';
import BallToCupPrivacy from './privacy/balltocup';
import CarWashPrivacy from './privacy/carwash';
import TaskimoPrivacy from './privacy/taskimo';
import CariTakipPrivacy from './privacy/caritakip'; // ✅ yeni import
import CariTakipTerms from './privacy/CariTakipTerms'; // veya './terms/CariTakipTerms'
import FitQueenTerms from './privacy/FitQueenTerms';
import FitQueenPrivacy from './privacy/fitqueen';
import KolayCRMPrivacy from './privacy/kolaycrm'; // ✅ yeni import
import KolayCRMTerms from './privacy/KolayCRMTerms'; // ✅ yeni import
import RandevuPrivacy from './privacy/randevu'; // ✅ yeni import
import RandevuTerms from './privacy/RandevuTerms'; // ✅ yeni import
import AracCuzdaniPrivacy from './privacy/araccuzdani'; // ✅ yeni import
import AracCuzdaniTerms from './privacy/AracCuzdaniTerms'; // ✅ yeni import
import WaterTempPrivacy from './privacy/watertemp'; // ✅ yeni import
import WaterTempTerms from './privacy/WaterTempTerms'; // ✅ yeni import
import ColdReadPrivacy from './privacy/coldread';
import ColdReadTerms from './privacy/ColdReadTerms';

function TermsWrapper() {
  const { appType } = useParams();

  if (appType === "caritakip") return <CariTakipTerms />;
  else if (appType === "fitqueen") return <FitQueenTerms />;
  else if (appType === "kolaycrm") return <KolayCRMTerms />; // ✅ yeni case
  else if (appType === "randevu") return <RandevuTerms />; // ✅ yeni case
  else if (appType === "araccuzdani") return <AracCuzdaniTerms />; // ✅ yeni case
  else if (appType === "watertemp") return <WaterTempTerms />; // ✅ yeni case
  else if (appType === "coldread") return <ColdReadTerms />;
  else return <div>Terms not found</div>;
}

// Parametreye göre hangi policy'nin gösterileceğini belirleyen sarmalayıcı bileşen
function PrivacyWrapper() {
  const { appType } = useParams();
  
  if (appType === "babyname") return <BabyNamePrivacy />;
  else if (appType === "balltocup") return <BallToCupPrivacy />;
  else if (appType === "carwash") return <CarWashPrivacy />;
  else if (appType === "taskimo") return <TaskimoPrivacy />;
  else if (appType === "caritakip") return <CariTakipPrivacy />; // ✅ yeni case
  else if (appType === "fitqueen") return <FitQueenPrivacy />;
  else if (appType === "kolaycrm") return <KolayCRMPrivacy />; // ✅ yeni case
  else if (appType === "randevu") return <RandevuPrivacy />; // ✅ yeni case
  else if (appType === "araccuzdani") return <AracCuzdaniPrivacy />; // ✅ yeni case
  else if (appType === "watertemp") return <WaterTempPrivacy />; // ✅ yeni case
  else if (appType === "coldread") return <ColdReadPrivacy />;
  else return <div>Privacy policy not found</div>;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy/:appType" element={<PrivacyWrapper />} />
          <Route path="/terms/:appType" element={<TermsWrapper />} />  {/* YENİ */}

      </Routes>
    </Router>
  );
}

export default App;